<template>
  <div class="card my-10">
    <puls-card-header v-if="!messageSent" :title="title" />
    <div v-if="!messageSent">
      <b-row v-if="loading" class="loading-row mt-3 mb-3">
        <div class="d-flex justify-content-center m-3">
          <div class="spinner-border text-primary"></div>
        </div>
      </b-row>
      <b-row v-if="!loading && error" class="error-row mb-3">
        <b-col>
          <div class="mt-4 d-flex align-items-center justify-content-center ">
            <i class="bi bi-exclamation-octagon-fillfs-3 text-danger mx-3"></i>
            <span class="text-danger"> {{ error }}</span>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="!loading">
        <div class="my-5">
          <div v-if="!report" class="followup-login m-auto">
            <b-col cols="6" class="mx-auto">
              <puls-form-input
                v-model="caseName"
                :placeholder="ft(featureName, 'followupLogin.caseLabel', $t)"
                :label="ft(featureName, 'followupLogin.caseLabel', $t)"
                autocomplete="off"
                :is-floating-label="true"
                class="mb-7"
              />
              <puls-form-input
                v-model="password"
                type="password"
                :placeholder="
                  ft(featureName, 'followupLogin.passwordLabel', $t)
                "
                autocomplete="new-password"
                :label="ft(featureName, 'followupLogin.passwordLabel', $t)"
                :is-floating-label="true"
                class="mb-7"
              />
            </b-col>
            <b-col cols="6" class="mx-auto d-flex justify-content-center mt-3">
              <b-button
                variant="primary"
                :disabled="!caseName.length || !password.length"
                class="btn-round btn-small mt-3"
                @click="getReport"
                >{{ ft(featureName, 'followup.buttons.submit', $t) }}</b-button
              >
            </b-col>
          </div>
          <div v-if="report" class="followup-case m-3">
            <span class="mx-3"
              >{{ ft(featureName, 'followup.statusLabel', $t) }} </span
            ><b>{{
              ft(featureName, `followup.status.${report.status}.title`, $t)
            }}</b>
            <p class="mt-3 text-muted">
              {{
                ft(
                  featureName,
                  `followup.status.${report.status}.description`,
                  $t
                )
              }}
            </p>
            <b-card>
              <case-messages
                :report="report"
                :organization-name="organizationName"
                :case-name="caseName"
                :password="password"
                :feature-name="featureName"
                :send-message="sendMessage"
              ></case-messages>
            </b-card>
          </div>
        </div>
      </b-row>
    </div>
    <div v-else>
      <b-row class="message-sent">
        <b-col cols="8" class="m-auto">
          <p class="d-flex align-items-center text-success m-auto">
            <i class="bi bi-check mr-3"></i>
            {{ $t('whistleblower.followup.messages.messageSent') }}
          </p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import LocalizableComponent from './LocalizableComponent.vue'
import CaseMessages from './CaseMessages.vue'
import ReporterService from '../services/ReporterService'

export default {
  name: 'FollowUp',
  components: {
    CaseMessages
  },
  extends: LocalizableComponent,
  props: {
    featureName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      organizationName: null,
      caseName: '',
      password: '',
      error: null,
      loading: false,
      report: null,
      messageSent: false
    }
  },
  computed: {
    organizationFullName() {
      return this.organizationName
    },
    title() {
      return this.ft(this.featureName, 'followupLogin.title', this.$t)
    }
  },
  mounted() {
    if (this.$route.query.o) {
      this.organizationName = this.$route.query.o
    } else {
      this.error = 'please follow a valid link'
    }
  },
  methods: {
    getReport() {
      this.loading = true
      this.error = null
      return ReporterService.getReport({
        organizationName: this.organizationName,
        caseName: this.caseName,
        password: this.password
      })
        .then(report => {
          this.report = report
        })
        .catch(error => {
          this.password = null
          if (error.response && error.response.status === 404) {
            this.error =
              'Could not get a report using that case id and password'
          } else {
            this.error = error
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    sendMessage() {
      this.messageSent = true
    }
  }
}
</script>

<style scoped>
.message-sent {
  min-height: 10em;
}
</style>
